import { getArray } from "../../../../../utils/mappersUtils/object";

import { checklistTemplateMapper } from "./checklistTemplateMapper";
import { checklistSegmentMapper } from "./checklistSegmentMapper";
import { checklistItemMapper } from "./checklistItemMapper";

/**
 * Given the entire "checklist template" API response, produce an array of translation rows:
 * 1) The template row
 * 2) One segment row for each segment
 * 3) One item row for each item in each segment
 */
export function checklistTranslationsFullMapper(raw) {
  let resultRows = [];

  resultRows.push(...checklistTemplateMapper(raw));

  const segments = getArray(raw, "segments");
  segments.forEach((seg) => {
    resultRows.push(...checklistSegmentMapper(seg));

    const items = getArray(seg, "items");
    items.forEach((it) => {
      resultRows.push(...checklistItemMapper(it));
    });
  });

  return resultRows;
}
